/*
 * Copyright (c) 2026 Oray Inc. All rights reserved.
 *
 * No Part of this file may be reproduced, stored
 * in a retrieval system, or transmitted, in any form, or by any means,
 * electronic, mechanical, photocopying, recording, or otherwise,
 * without the prior consent of Oray Inc.
 *
 * @Author: huangweiliang<huangweiliang@oray.com>
 * @Date: 2026-01-13
 * @LastEditors: huangweiliang<huangweiliang@oray.com>
 * @LastEditTime: 2026-01-09 19:12:36
 * @FileName: index.ts
 * @Description: []
 */

import { config as globalConfig } from './global'
import {
  init,
  handlePC,
  handleMobile,
  destroy,
  decidePCLoginStrategy,
  decideMobileLoginStrategy,
  parseClientParam,
} from './modules/fast-login/index'
import clientWeb from './modules/client-web/index'

// 1. 导出核心业务模块: 快捷登录
export const fastLogin = {
  init,
  handlePC,
  handleMobile,
  destroy,
  // 暴露内部决策函数
  decidePC: decidePCLoginStrategy,
  decideMobile: decideMobileLoginStrategy,
  parseClientParam,
}

// 2. 导出核心业务模块: 客户端 Web 桥接
export { clientWeb }

// 3. 导出全局配置方法
export const config = globalConfig

// 4. 导出版本号
export const version = '1.0.0'

// 5. 定义主对象
const oray: {
  config: typeof config
  fastLogin: typeof fastLogin
  clientWeb: typeof clientWeb
  version: string
} = {
  config,
  fastLogin,
  clientWeb,
  version,
}

// 6. 导出类型和工具
export * from './types'
export * from './modules/fast-login/types'
export * from './modules/client-web/types'
export { OrayConfig, getGlobalEnv, isDebug } from './global'

// 导出主对象的类型
export type OraySDK = typeof oray

// 为 UMD 全局变量提供类型声明
declare global {
  interface Window {
    oray: OraySDK
  }
  const oray: OraySDK
}

// 默认导出主对象
export default oray
